import React, { cloneElement } from 'react';
import IconPdf from '../svg/IconPdf';
import AsButton from '../AsButton';
import { gridBorder } from './styles';
import DataCell from './DataCell';

const buttonStyle = {
    width: 85,
    height: 34,
    fontSize: 15,
    fontWeight: 500
};

const CustomCell = ({
    rowIndex,
    accessor,
    accessorDisabled,
    customType,
    onCustomClick,
    data,
    scrollPxH,
    scrollPxV,
    isSticky,
    isHighlighted,
    style,
    onHover,
    component,
    rowHeight,
    deleteRowSelected,
    highlightedIdx,
    setHighlightedIdx,
    highlightOnClick = false
}) => {
    const cell = {
        ...gridBorder,
        padding: 0,
        textAlign: 'center',
        backgroundColor: isHighlighted
            ? '#dcffff'
            : deleteRowSelected
            ? '#FDF1D6'
            : rowIndex % 2 === 0
            ? '#f7f7f7'
            : '#ffffff',
        zIndex: 100 - rowIndex,
        height: rowHeight
    };
    let cellComponent;
    switch (customType.toLowerCase()) {
        case 'pdf':
            cellComponent = (
                <IconPdf
                    id={`pdf${rowIndex}`}
                    style={{ width: 46 }}
                    onClick={() => onCustomClick(customType, data)}
                />
            );
            break;
        case 'button':
            cellComponent = (
                <AsButton
                    id={`button${rowIndex}`}
                    style={buttonStyle}
                    disabled={data[accessorDisabled]}
                    handleClick={() => onCustomClick(customType, data)}
                >
                    {data[accessor]}
                </AsButton>
            );
            break;

        case 'component':
            cellComponent = cloneElement(component, {
                data: data,
                field: accessor, // Named as 'field' as that's the key used to define the prop in column definitions
                isHighlighted,
                isSticky,
                onHover,
                scrollPxH,
                scrollPxV,
                rowIndex,
                style,
                onCustomClick: () =>
                    onCustomClick(customType, data, data[accessor])
            });
            break;
    }

    return (
        <DataCell
            rowIndex={rowIndex}
            style={{ ...cell, ...style }}
            scrollPxH={scrollPxH}
            scrollPxV={scrollPxV}
            isSticky={isSticky}
            isHighlighted={isHighlighted}
            onHover={onHover}
            highlightedIdx={highlightedIdx}
            setHighlightedIdx={setHighlightedIdx}
            highlightOnClick={highlightOnClick}
        >
            {cellComponent}
        </DataCell>
    );
};

export default CustomCell;
